const productionPaths = {
  openContractAdmin: "/api/contracts/admin/open",
  createContractInvite: "/api/contracts/invites/create",
  verifyContractInvite: "/api/contracts/invites/verify",
  submitContract: "/api/submit-contract",
};

export function contractApiEndpoint(functionName) {
  if (process.env.REACT_APP_CONTRACT_API_BASE) {
    return `${process.env.REACT_APP_CONTRACT_API_BASE.replace(/\/$/, "")}/${functionName}`;
  }
  if (window.location.hostname === "localhost") {
    return `https://us-central1-dr-tour-festival.cloudfunctions.net/${functionName}`;
  }
  return productionPaths[functionName];
}
